import React from 'react';
import PatientLastReviewedGenericAdapter from '../../../pages/clinicworkspace/components/ReviewPatientToggle/PatientLastReviewedGenericAdapter';

const PatientLastReviewed = (props) => {
  return <PatientLastReviewedGenericAdapter {...props} />;
};

export default PatientLastReviewed;
